import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { OrcadentTreatmentPackages } from "libs/treatments/src/lib/models/treatment.model";

@Component({
	selector: "ux-treatment-packages-orcadent",
	standalone: true,
	imports: [CommonModule, TranslateModule],
	templateUrl: "./treatment-packages-orcadent.component.html",
	styleUrl: "./treatment-packages-orcadent.component.scss"
})
export class TreatmentPackagesOrcadentComponent {
	@Input({ required: true }) packages: OrcadentTreatmentPackages;
}
